<template>
  <div>
    <title>平台公告</title>
    <section class="mainPart">
        <!-- S 列表 -->
        <div class="messageListTable individualiz">
          <el-table class="comTable messageTable" ref="msgTable" :data="companyheads" border :maxHeight="tableHeight">
          <el-table-column label="序号" type="index" ></el-table-column>
          <el-table-column label="公告标题"min-width="220">
            <template  slot-scope="scope">
              <p class="textFl" :title="scope.row.title">
                {{scope.row.title}}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="状态"  min-width="130">
            <template slot-scope="scope">
              <el-switch :value="scope.row.status ? false : true" @change="handleStatus(scope.row,scope.row.status)" :width="55" class="isSwitch" :active-text="scope.row.status == 0 ?'发布':'下线'"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <p class="handle">
                  <span title="详情" class="detailA"  @click="getCommendShow(scope.row.id,3)"><i class="icondetails"></i></span>
                </p>
              </template>
          </el-table-column>
            <template slot="empty">
              <div class="noData"><span>暂无数据</span></div>
            </template>
          </el-table>
          <!-- S 分页 -->
          <Page :pageTotal="pageTotal" :currentPage="currentPage" :pageSize="pageSize" @nowPageParam="nowPageParam"></Page>
          <!-- E 分页 -->
          </div>
        <!-- E 列表 -->

          <!--S 帮助文档详情组件-->
          <HelpDetail :helpDetailBox="helpDetailShow" :doccode="doccode" :typesd="typesd" @closeHPBox="helpDetailShow = false"></HelpDetail>
          <!--E 帮助文档详情组件-->

    </section>
  </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
import Vue from 'vue';
import api from '@/apis/api';
export default {
  name: 'PlatformBulletin',
  data () {
    return {
      typesd:'',
      doccode:'',
      pageTotal:0, //总数
      currentPage:1, // 页数
      pageSize:30, // 条数
      isMessages:true,//消息类型时展示关闭按钮和“升级、维护、推广”
      mesgType:0, //默认选中
      //检索
      searchForm: {
        bulletinType: [],//类型
      },
      bulletinList:[ 
        {label:'维护',value:'0'},
        {label:'升级',value:'1'},
        {label:'推广',value:'2'},
        {label:'其他',value:'3'},
      ],//公告类型 0：升级；1：维护；2：推广
      companyheads:[],
      tableHeight: window.innerHeight*.8, //表格动态高度
      helpDetailShow:false, //消息详情弹窗
    }
  }, 
  filters: {

  },
  watch: {
    mesgType(val){
      setTimeout(()=>{
          this.getHeight();
      },200)
    },
    'searchForm.bulletinType':function(val){
       this.pageSize = 30;
       this.currentPage = 1;
       this.companyHead();
    }
  },
  //================================================ 组件 ================================================
  components: {
    Page: resolve => require(["@/components/common/Page.vue"],resolve),
    HelpDetail: resolve => require(["@/components/common/HelpDetail.vue"], resolve), //查看帮助详情组件
  },
  //================================================ 方法 ================================================
  methods: {
    getCommendShow(doccode,type){
      this.typesd = type;
      this.doccode = doccode;
      this.helpDetailShow = true;
    },
    // 分页
    nowPageParam(val,vals){
      this.pageSize = val;
      this.currentPage = vals;
      this.companyHead();
    },
    //关闭详情弹框
    closeMessDlog(){
      this.helpDetailShow = false;
    },
    //动态获取表格高度
    getHeight() {
        let tbHeight = this.$refs.msgTable.$el.offsetTop; //顶部检索条件占据的高度
        this.tableHeight = window.innerHeight - tbHeight - 150; 
    },
    companyHead(){
      let param ={
          status:0,
          bbstype:1,
          pageparam:{
                pagesize: this.pageSize, //每页条数
                currentpage: this.currentPage, //当前页数
          }
      }
      api.GET_BBSLIST(param).then(res =>{
        this.toTableTop('msgTable');
         if(res.data.status=="200"&&res.data.data!=null){
           this.companyheads = res.data.data;
           this.pageTotal = res.data.pagebean.totalnum;
         }else{
           this.pageTotal = 0;
           this.companyheads = [];
         }
      })
    },
  },
  //============================================== 生命周期 ==============================================
  created() {
      //页面浏览器视窗变化绑定resize事件
      window.addEventListener("resize", this.getHeight);
  },
  mounted () {
      this.companyHead();
      //在dom渲染之后
      setTimeout(()=>{
          this.getHeight();
      },200)
  }, 
  destroyed(){ 
      window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
  }
}
</script>

<style scoped>
.mainPart{
    padding: 20px;
    height: calc(100% - 50px);
}
.pdr70 {padding-right:70px; width:calc(100% - 70px);}
.comTable >>> .el-tag {height: 16px; padding: 0 2px;line-height: 14px; font-size: 12px;}
.searchForm {padding-top:64px;}
.messageListTable {position: relative;}
.messageListTable h4,.messageListTable p {color: #333;}
.pr50 {padding-right: 50px;cursor: pointer;}
.pr50 h4 {color: #333; font-weight: bold;padding-bottom:10px;}
.pr50 p {color: #666; line-height: 22px; color:#999;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;}
.pr50:hover h4{color: var(--main-color); }
.pr10{padding-right: 10px;}
.bottom {position: absolute; bottom: 0; right: 0;}

.commonNum {color: #333;}
.individualiz >>> form {padding-top: 10px !important; border: none;}
.disSpan {display: inline-block; width: 100%; text-align: right;color:#999;}
/* .messageTable {border: none;} */
.messageTable.el-table--border >>> td, .messageTable.el-table--border >>> th {padding:20px 0;}
/* .messageTable >>> thead {display: none;} */
/* .messageTable >>> .cell {padding-left: 0 !important;} */
.messageTable::after, .messageTable::after {display: none;}
.messageTable.el-table--border{border: 1px solid #EBEEF5;}
</style>


// WEBPACK FOOTER //
// src/views/MessageCenter/NbuPlatformBulletin.vue